import { Button } from "antd";
import { FilterFilled } from "@ant-design/icons";
import { buildFilters } from "../../../helpers/utilityHelpers";
import AudbilityStatusTag from "../shared/components/AudbilityStatusTag/AudbilityStatusTag";
import { SEE_MORE_LABEL } from "./constants";
import classes from "./AudbilityUsers.module.scss";

const filterIcon = <FilterFilled className={classes.FilterIcon} />;

const buildFilterableColumn = (users, { title, dataIndex, width }) => ({
  title,
  dataIndex,
  key: dataIndex,
  width,
  filters: buildFilters(users, dataIndex),
  filterIcon,
  filterSearch: true,
  onFilter: (value, record) => record[dataIndex] === value,
});

export const getAudbilityUsersColumns = ({ users, onSeeMore }) => [
  buildFilterableColumn(users, { title: "Sub", dataIndex: "sub", width: "16%" }),
  buildFilterableColumn(users, { title: "Nome", dataIndex: "name", width: "19%" }),
  buildFilterableColumn(users, { title: "Email", dataIndex: "email", width: "20%" }),
  {
    ...buildFilterableColumn(users, {
      title: "Status",
      dataIndex: "status",
      width: "13%",
    }),
    render: (status, record) => (
      <AudbilityStatusTag statusKey={record.statusKey} label={status} />
    ),
  },
  buildFilterableColumn(users, {
    title: "Cadastrado",
    dataIndex: "createdAt",
    width: "16%",
  }),
  {
    title: "Ações",
    key: "actions",
    width: "16%",
    render: (_, record) => (
      <Button
        className={classes.SeeMoreButton}
        onClick={() => onSeeMore(record)}
      >
        {SEE_MORE_LABEL}
      </Button>
    ),
  },
];
